import { initAccordion } from '../../components/accordion';
// import themeEditor from './themeEditor';

const adjustFooter = () => {
  const $footer = $('footer.shopify-section-group-footer-group');
  const window_height = $(window).innerHeight();
  const pre_header_height = $('.shopify-section.preheader').outerHeight() || 0;
  const header_height = $('.shopify-section.header').outerHeight() || 0;
  const footer_height = $footer.outerHeight() || 0;
  let main_height = $('main').outerHeight(true) || 0;

  $('main').css('min-height', 'unset');
  if (window.theme.breakpoints.current === 'mobile') {
    // A filter has been opened on a collection page
    if ($('.mobile-filter__options.active').length) {
      $('main').css('min-height', $('.mobile-filter__options.active').outerHeight() + $('.mobile-filter__options.active').position().top);
      main_height = $('main').height();
    }
  }

  if (main_height + header_height + pre_header_height + footer_height + window.theme.gutter < window_height) {
    $footer.removeClass('footer--unstick');
  } else {
    $footer.addClass('footer--unstick');
  }

  $footer.addClass('active');
};

export default () => {
  initAccordion('[data-mobile-footer-accordion]');

  $(window).on('resize', _.debounce(() => {
    adjustFooter();
  }, 100));

  // themeEditor();
};
